// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global google, lyyski, FWP, handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        current_position: 0,
        markersArray: [],
        previousZoomLevel: 0,
        loadingMoreProperties: false,
        styles: [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            }
        ],

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }

            wntrTheme.rluCalcPropertyInfoWindowWidth();
        },

        /**
         * Dropdown / submenu handler
         */
        __submenuHandler: () => {
            const dropdownToggle = wntrTheme.body.find('.menu-item-has-children');

            if(!dropdownToggle.length) {
                return false;
            }

            dropdownToggle.on('click', function(event) {
                if($(event.target).is('a')) {
                    return;
                }
                $(this).toggleClass('is-active');
                $(this).find('.toggle-sub-menu').toggleClass('is-active');
                $(this).find('.sub-menu').slideToggle(100);
            });
        },

        __propertyCardBadgeBiddingCountDown: function() {
            const cardCountdowns = wntrTheme.body.find('.property__badge--active-bidding');

            cardCountdowns.each(function() {
                const cardCountdown = $(this);
                const biddingEnds = new Date(cardCountdown.data('bidding-ends')).getTime();

                function updateCountdown() {
                    const now = new Date().getTime();
                    const timeLeft = biddingEnds - now;

                    if(timeLeft < 0) {
                        cardCountdown.text('Budgivningen är avslutad');
                        cardCountdown.removeClass('is-active').addClass('has-ended');
                        clearInterval(interval);
                        return;
                    }

                    cardCountdown.addClass('is-active').removeClass('has-ended');

                    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                    let countdownText = '';
                    if(days > 0) {
                        countdownText += days + 'd ';
                    }
                    if(hours > 0 || days > 0) {
                        countdownText += hours + 'h ';
                    }
                    if(minutes > 0 || hours > 0 || days > 0) {
                        countdownText += minutes + 'm ';
                    }
                    countdownText += seconds + 's';

                    cardCountdown.find('#time-left').text(countdownText);
                }

                const interval = setInterval(updateCountdown, 1000);
                updateCountdown(); // Initial call to display the countdown immediately
            });
        },

        /**
         * Handle custom calendly section
         */
        __customCalendly: function() {
            wntrTheme.body.find('.custom__calendar-card').on('click', function(e) {
                e.preventDefault();
                wntrTheme.body.find('.custom__calendar-card').removeClass('active');
                wntrTheme.body.find('.custom__calendar').removeClass('active');

                $(this).addClass('active');
                wntrTheme.body.find('.custom__calendar[data-cal="' + $(this).data('cal') + '"]').addClass('active');
                wntrTheme.body.find('.custom__calendars')[0].scrollIntoView({ behavior: "smooth" });
            });
        },

        /**
         * Custom mobile gallery
         */
        __customMobileGallery: function() {
            wntrTheme.body.find('.property-gallery-trigger').on('click', function(e) {
                if($(window).width() < 960) {
                    e.preventDefault();
                    wntrTheme.current_position = wntrTheme.document.scrollTop();
                    wntrTheme.body.find('.property-gallery-mobile__header').addClass('active');
                    wntrTheme.body.find('.property-gallery-mobile').addClass('active');
                    wntrTheme.body.addClass('body--fixed-mobile');
                    return false;
                }
            });

            wntrTheme.body.find('.property-gallery-mobile__header button').on('click', function() {
                wntrTheme.body.find('.property-gallery-mobile__header').removeClass('active');
                wntrTheme.body.find('.property-gallery-mobile').removeClass('active');
                wntrTheme.body.removeClass('body--fixed-mobile');
                wntrTheme.document.scrollTop(wntrTheme.current_position);
            });
        },

        /**
         * Set Cookie
         */
        setCookie: function(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },

        /**
         * Get Cookie
         */
        getCookie: function(cname) {
            const name = cname + "=";
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while(c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if(c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },

        /**
         * Start popup timer
         */
        startPopupTimer: function(seconds) {

            const interval = setInterval(function() {

                wntrTheme.setCookie('popup_timeout', seconds, 2);

                if(--seconds < 0) {
                    wntrTheme.body.find('.popup').trigger('click');

                    wntrTheme.body.find('.popup').find('.fancybox-button').on('click', function() {
                        wntrTheme.setCookie('user_has_closed_popup', 'true', 2);
                    });

                    wntrTheme.body.find('.popup__link').on('click', function() {
                        wntrTheme.setCookie('user_has_closed_popup', 'true', 2);
                        window.location.href = $(this).attr('href');
                    });

                    clearInterval(interval);
                }
            }, 1000);
        },

        /**
         * Calculate screen width
         */
        rluCalcPropertyInfoWindowWidth: function() {
            const information = wntrTheme.body.find('.screen-section .information');

            if(information) {
                const max = Math.max(...information.map(function(i, o) {
                    return jQuery(o).width();
                }));

                information.width(max);
            }
        },

        /**
         * Hotfix raspberry pi screens
         */
        __reloadScreenPageEveryFourthHour: function() {
            if(wntrTheme.body.hasClass('single-screen')) {
                setInterval(function() {
                    const randomHash = Math.random().toString(36).substring(7);
                    const newUrl = window.location.href.split('?')[0] + '?' + randomHash;
                    window.location.href = newUrl + '&cacheBust=' + new Date().getTime();
                }, 1000 * 60 * 10); //  Once every 10 minute
            }
        },

        /**
         * Toggle search page tabs
         */
        __toggleSearchPageTabs: function() {
            const $search_tab = wntrTheme.body.find('.search__results-tab');

            $search_tab.on('click', function() {
                wntrTheme.body.find('.search__results-tab').removeClass('is-active');
                wntrTheme.body.find('.search__result').removeClass('is-active');

                $(this).addClass('is-active');
                wntrTheme.body.find('.search__result--' + $(this).data('tab')).addClass('is-active');
            });
        },

        /**
         * fancybox popup handler
         */
        __fancyboxPopupHandler: function() {

            if(wntrTheme.body.hasClass('lyyski__popup')) {

                window.onload = function() {
                    let seconds = null;

                    if(wntrTheme.getCookie('popup_timeout').length) {
                        seconds = wntrTheme.getCookie('popup_timeout');
                    } else {
                        seconds = parseInt(wntrTheme.body.find('.popup').data('timeout'));
                    }

                    if(!wntrTheme.getCookie('user_has_closed_popup') || parseInt(wntrTheme.getCookie('popup_timeout')) > 0) {
                        wntrTheme.startPopupTimer(seconds);
                    }
                };
            }
        },

        /**
         * Load more properties with infinite scroll
         */
        __loadMorePropertiesOnScroll: function() {
            if(wntrTheme.body.find('.archive-property-preview__properties, .page-section-lyyski_home').length) {
                const $load_more_properties_trigger = wntrTheme.body.find('.archive-property-preview__show-more-objects');

                $(document).on('facetwp-loaded', function() {
                    wntrTheme.loadingMoreProperties = false;
                });

                let map_scroll_timeout = null;
                const map_scroll_throttle = 50;
                $(window).on('scroll', function() {
                    if(!map_scroll_timeout) {
                        map_scroll_timeout = setTimeout(function() {
                            const $load_more_button = wntrTheme.body.find('.archive-property-preview__show-more-objects.map--hidden .facetwp-load-more:not(.facetwp-hidden)');
                            if(isScrolledIntoView($load_more_properties_trigger) && $load_more_button.length && !wntrTheme.loadingMoreProperties) {
                                $load_more_button.trigger('click');
                                wntrTheme.loadingMoreProperties = true;
                            }

                            map_scroll_timeout = null;
                        }, map_scroll_throttle);
                    }
                });
            }

            function isScrolledIntoView(elem) {
                const docViewTop = $(window).scrollTop();
                const docViewBottom = docViewTop + $(window).height();

                const elemTop = $(elem).offset().top;
                const elemBottom = elemTop + $(elem).height();

                return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom));
            }
        },

        /**
         * Scroll to broker section for single property
         */
        __scrollToBrokerSectionSingleProperty: function() {
            const $scrollToBrokersBtn = wntrTheme.body.find('.property-information__broker-link a');

            if($scrollToBrokersBtn.length) {
                $scrollToBrokersBtn.on('click', function(e) {
                    e.preventDefault();

                    $('html, body').animate({
                        scrollTop: ($('#property-section-brokers').offset().top - ($(window).width() >= 720 ? 70 : 50))
                    }, 500);
                });
            }
        },

        /**
         * Handle single property facts
         */
        __handleSinglePropertyFacts: function() {
            const $facts = wntrTheme.body.find('.property-fact');

            if($facts.length) {
                $.each($facts, function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * Handle single property map
         */
        __handleScreenUpdateOnObjectUpdate: () => {
            if(wntrTheme.body.hasClass('single-screen')) {

                const postData = [];
                const action = 'handle_object_update';
                const screenId = wntrTheme.body.find('.screen-section').data('screen-id');

                setInterval(() => {

                    $.each(wntrTheme.body.find('.screen-property'), function() {
                        const id = $(this).data('id');
                        const update = $(this).data('update');
                        postData.push({ screenId, id, update });
                    });

                    const data = {
                        'action': action,
                        'data': postData
                    };

                    $.ajax({
                        url: lyyski.ajax_url,
                        data: data,
                        type: 'POST',
                        dataType: 'json',
                        success: function(response) {
                            if(response && response['type'] === 'rand') {
                                wntrTheme.body.find('.screen-property-wrapper').html(response['html']);
                                postData.length = 0;
                            } else {
                                wntrTheme.body.find(`#${response['id']}.screen-property`).first().replaceWith(response['html']);
                                postData.length = 0;
                            }

                            wntrTheme.rluCalcPropertyInfoWindowWidth();
                        },
                        fail: function() {
                            postData.length = 0;
                        }
                    });
                }, 60000);
            }
        },

        /**
         * Handle single property map
         */
        __handleSinglePropertyMap: function() {
            const $map_element = wntrTheme.body.find('.property-map');

            if($map_element.length) {
                wntrTheme.body.find('.property-map__preview-trigger').on('click', function() {
                    initSinglePropertyMap();
                    wntrTheme.body.find('.property-map__preview, .property-map__preview-trigger').remove();
                });
            }

            function initSinglePropertyMap() {
                if(!$map_element.hasClass('property-map--initialized')) {
                    $map_element.addClass('property-map--initialized');
                    const lat = $map_element.data('lat');
                    const lng = $map_element.data('lng');
                    const zoomMobile = $map_element.data('zoom-mobile');
                    const zoomDesktop = $map_element.data('zoom-desktop');
                    const title = $map_element.data('title');
                    const address = $map_element.data('address');

                    const map = new google.maps.Map($map_element[0], {
                        zoom: $(window).width() >= 720 ? zoomDesktop : zoomMobile,
                        disableDefaultUI: true,
                        center: new google.maps.LatLng(lat, lng),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        gestureHandling: 'cooperative',
                        zoomControl: true,
                        streetViewControl: true,
                        fullscreenControl: true,
                        styles: wntrTheme.styles

                    });

                    const infowindow = new google.maps.InfoWindow();

                    const marker = new google.maps.Marker({
                        position: new google.maps.LatLng(lat, lng),
                        map: map,
                        animation: google.maps.Animation.DROP,
                        icon: {
                            url: lyyski.get_template_directory_uri + '/src/images/pin.svg',
                            size: new google.maps.Size(20, 20),
                            scaledSize: new google.maps.Size(20, 20)
                        }
                    });

                    google.maps.event.addListener(marker, 'click', (function(marker) {
                        return function() {
                            infowindow.setContent('<div class="gmap__info-window"><h2>' + title + '</h2><p>' + address + '</p></div>');
                            infowindow.open(map, marker);
                        };
                    })(marker));
                }
            }
        },

        /**
         * Toggle single property descriptions
         */
        __toggleSinglePropertyDescriptions: function() {
            const $toggleBtn = wntrTheme.body.find('.property-information__content-text-toggle');

            $toggleBtn.on('click', function() {
                const $btn = $(this);

                $btn.toggleClass('is-active');
                $btn.closest('.property-information__content-inner').find('.property-information__content-text').toggleClass('is-active');

                if($btn.hasClass('is-active')) {
                    $btn.find('span').text($btn.data('read-less-text'));
                } else {
                    $btn.find('span').text($btn.data('read-more-text'));
                }
            });
        },

        /**
         * Toggle header menu
         */
        __toogleHeaderMenu: function() {
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');
            const toggleHeaderElements = wntrTheme.body.find('.header__toggle-menu, .header__navigation-overlay, .header__navigation-close, .header__toggle-search');

            toggleHeaderElements.on('click', function() {
                if(wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('body--fixed');
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    toggleHeaderButton.removeClass('is-active');
                    if(wntrTheme.current_position <= 30 && !wntrTheme.body.find('header').hasClass('header--mobile-buttons')) {
                        wntrTheme.body.find('.header').removeClass('header--solid');
                    }

                    if($(window).width() <= 705) {
                        wntrTheme.document.scrollTop(wntrTheme.current_position);
                    }
                } else {
                    wntrTheme.body.addClass('header--mobile-menu-active');
                    toggleHeaderButton.addClass('is-active');

                    // Focus search if search button is clicked
                    if($(this).hasClass('header__toggle-search')) {
                        wntrTheme.body.find('.header__navigation-search input[type="search"]').focus();
                    }

                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();

                    // SetTimeout till the css animation has ended
                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                }
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('body--fixed');
                    toggleHeaderButton.removeClass('is-active');
                }
            });
        },

        /**
         * Toogle read more text content
         */
        __toggleReadMoreTextContent: () => {
            wntrTheme.body.find('.text-block__content-read-more').on('click', function() {
                $(this).closest('.text-block__content--expandable').addClass('expanded');
            });
        },

        /**
         * Toggle header background color on scroll
         */
        __toggleHeaderBackground: () => {
            let scrollTimeout = null;
            const throttle = 50;

            if(wntrTheme.body.find('header').hasClass('header--mobile-buttons')) return;

            toggleHeaderBackgroundClass();

            // Simple scroll throttle
            $(window).on('scroll', function() {
                if(!scrollTimeout) {
                    scrollTimeout = setTimeout(function() {
                        toggleHeaderBackgroundClass();
                        scrollTimeout = null;
                    }, throttle);
                }
            });

            function toggleHeaderBackgroundClass() {
                const scroll_length = 30;
                const scroll = $(window).scrollTop();

                if(scroll >= scroll_length) {
                    wntrTheme.body.find('header').addClass('header--solid');
                } else {
                    wntrTheme.body.find('header').removeClass('header--solid');
                }
            }
        },

        /**
         * Add class to body if iOS
         */
        __addBodyClassIfIOS: function() {
            if(iOS()) {
                wntrTheme.body.addClass('device--ios');
            }

            function iOS() {
                return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)
                    // iPad on iOS 13 detection
                    || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
            }
        },


        /**
         * Init accordions
         */
        __initAccordions: () => {
            if(wntrTheme.body.find('.handorgel').length) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * Handle toggle events
         */
        __toggleHandler: () => {
            const readMore = wntrTheme.body.find('.handorgel__content__inner__read-more');

            if(readMore.length) {
                readMore.on('click', function() {
                    $(this).toggleClass('handorgel__content__inner__read-more--active');
                    $(this).parent('.handorgel__content__inner').toggleClass('handorgel__content__inner--expandable');
                    $(this).parent('.handorgel__content__inner').toggleClass('handorgel__content__inner--expanded');
                    $(this).closest('.handorgel__content').css('height', 'auto');
                });
            }
        },

        /**
         * Toggle functionality for additional filters
         */
        __filterToggle: () => {
            const toggleBtn = wntrTheme.body.find('.archive-property-preview__toggle');
            if(toggleBtn.length) {
                toggleBtn.on('click', () => {
                    toggleBtn.toggleClass('is-active');
                    wntrTheme.body.find('.facetwp-additional-filters').toggleClass('is-active');
                });
            }
        },

        /**
         * On facet loaded/refresh event
         */
        __onFacetLoaded: () => {
            if(wntrTheme.body.hasClass('post-type-archive-property')) {

                const slider = wntrTheme.body.find('.archive-property-preview__slider');
                const cards = wntrTheme.body.find('.archive-property-preview__properties');
                let isInitLoad = true;

                $(document).on('facetwp-loaded', function() {

                    if(!isInitLoad) {
                        wntrTheme.body.find('.archive-property-preview__slider').remove();
                    }

                    wntrTheme.body.find('.property--card').children('.property__top-wrapper').matchHeight();
                    wntrTheme.body.find('.property__bottom-wrapper').matchHeight();
                    wntrTheme.body.find('.property__address').matchHeight();


                    //document.addEventListener('facetwp-loaded', function() {
                    //    //wntrTheme.body.find('.archive-property-preview__slider').remove();
                    //});

                    if(!isInitLoad && slider.length && !slider.hasClass('is-disabled') || window.location.search.length) {
                        wntrTheme.body.find('.archive-property-preview__slider').addClass('is-disabled');
                    }

                    cards.removeClass('is-loading');
                    isInitLoad = false;
                });

                $(document).on('facetwp-refresh', function() {
                    cards.addClass('is-loading');
                });
            }
        },

        /**
         * __handleCustomFacetwpMapPins
         */
        __handleCustomFacetwpMapPins: () => {
            const showMapBtn = wntrTheme.body.find('.archive-property-preview__toggle-map');
            const showMoreObjects = wntrTheme.body.find('.archive-property-preview__show-more-objects');
            const mapWrapper = wntrTheme.body.find('.archive-property-preview__map');
            const filterBtn = wntrTheme.body.find('.archive-property-preview__toggle-filter');
            let map = null;
            let init = true;
            let currentZoom = null;
            let zoomLevel = 1;

            const blackBullet = {
                url: lyyski.get_template_directory_uri + '/src/images/bullet.svg',
                size: new google.maps.Size(17, 17),
                scaledSize: new google.maps.Size(17, 17)
            };

            const yellowBullet = {
                url: lyyski.get_template_directory_uri + '/src/images/bullet-yellow.svg',
                size: new google.maps.Size(17, 17),
                scaledSize: new google.maps.Size(17, 17)
            };

            filterBtn.on('click', () => {
                wntrTheme.body.toggleClass('filter-map-is-active');

                if(wntrTheme.body.hasClass('filter-map-is-active')) {
                    $('html, body').animate({ scrollTop: 0 }, 50);
                }
            });

            if(showMapBtn.length) {
                showMapBtn.on('click', () => {
                    showMapBtn.toggleClass('map-btn-is-active');
                    wntrTheme.body.toggleClass('property-map-is-active');
                    showMoreObjects.toggleClass('map--hidden');

                    $(document).on('facetwp-refresh', () => {
                        mapWrapper.addClass('is-loading');
                        clearActiveMarker();
                    });

                    if(showMapBtn.hasClass('map-btn-is-active')) {
                        FWP.soft_refresh = true;
                        FWP.refresh();
                    } else if(!showMapBtn.hasClass('map-btn-is-active')) {
                        wntrTheme.body.removeClass('filter-map-is-active');
                        FWP.refresh();
                    }

                    // make sure to only load map once
                    if(init) {
                        setupMap();
                    }

                    $(document).on('facetwp-loaded', () => {
                        clearCurrentMarkers();
                        renderMarkers();
                        if(mapWrapper.hasClass('is-loading')) {
                            mapWrapper.removeClass('is-loading');
                        }
                        if(!init) {
                            map.setZoom(currentZoom);
                        }
                    });

                    toggleMap();

                    if(init) {
                        init = false;
                    }
                });
            }

            function toggleMap() {
                wntrTheme.body.find('.archive-property-preview__properties').toggleClass('map-active');
                wntrTheme.body.find('.archive-property-preview__show-more-objects').toggleClass('map-active');
                wntrTheme.body.find('.facetwp-facet-sortering').toggleClass('map-active');
                mapWrapper.toggleClass('map-active');

                $('html, body').animate({
                    scrollTop: $("#facetwp-map").offset().top - ($(window).width() >= 720 ? 70 : 50)
                }, 500);
            }

            function setupMap() {

                map = new google.maps.Map(document.getElementById('facetwp-map'), {
                    zoom: 9,
                    disableDefaultUI: true,
                    center: new google.maps.LatLng(60.198116, 19.994465),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'greedy',
                    zoomControl: true,
                    streetViewControl: true,
                    fullscreenControl: true,
                    styles: wntrTheme.styles
                });

                google.maps.event.addListener(map, 'zoom_changed', function() {
                    let zoomLevelChanged = false;

                    if(map.getZoom() < 14) {
                        zoomLevel = 1;
                    } else {
                        zoomLevel = 2;
                    }

                    if(wntrTheme.previousZoomLevel === 13 || wntrTheme.previousZoomLevel === 14) {
                        zoomLevelChanged = true;
                    }

                    wntrTheme.previousZoomLevel = map.getZoom();

                    if(zoomLevelChanged) {
                        for(let i = 0; i < wntrTheme.markersArray.length; i++) {
                            if(zoomLevel === 2) {
                                wntrTheme.body.find('.gm-style-iw-t').addClass('is-visible');
                                wntrTheme.markersArray[i].getIcon().size = new google.maps.Size(0, 0);
                                wntrTheme.markersArray[i].getIcon().scaledSize = new google.maps.Size(0, 0);
                            } else {
                                wntrTheme.body.find('.gm-style-iw-t').removeClass('is-visible');
                                wntrTheme.markersArray[i].getIcon().size = new google.maps.Size(17, 17);
                                wntrTheme.markersArray[i].getIcon().scaledSize = new google.maps.Size(17, 17);
                            }
                            currentZoom = map.getZoom();
                        }
                    }
                });
            }

            function clearCurrentMarkers() {
                for(let i = 0; i < wntrTheme.markersArray.length; i++) {
                    wntrTheme.markersArray[i].setMap(null);
                }
                wntrTheme.markersArray = [];
            }

            function renderMarkers() {
                let index = 0;

                const url = new URL(window.location.href);
                let filterActive = false;
                if(
                    url.searchParams.get('_budgivning') ||
                    url.searchParams.get('_kommuner') ||
                    url.searchParams.get('_bostadstyper') ||
                    url.searchParams.get('_rum') ||
                    url.searchParams.get('_max_rum') ||
                    url.searchParams.get('_storlek') ||
                    url.searchParams.get('_pris') ||
                    url.searchParams.get('_nyproduktion') ||
                    url.searchParams.get('_hiss') ||
                    url.searchParams.get('_strandobjekt') ||
                    url.searchParams.get('_bastu') ||
                    url.searchParams.get('_uteplats')
                ) {
                    filterActive = true;
                }

                const $markers = filterActive ? $('.property--card.has-coordinates') : $('.property--map.has-coordinates');
                $markers.each(function() {
                    const lat = $(this).data('latitude');
                    const lng = $(this).data('longitude');
                    const price = $(this).data('price');
                    const id = $(this).data('id');

                    const infowindow = new google.maps.InfoWindow({
                        content: '<button data-index=' + index + ' id=' + id + ' data-id=' + id + ' class="info-window" type="button">' + price + '</button>',
                        disableAutoPan: true
                    });

                    google.maps.event.addListener(infowindow, 'domready', function() {
                        if(zoomLevel === 2) {
                            wntrTheme.body.find('.gm-style-iw-t').addClass('is-visible');
                        }
                    });

                    const marker = new google.maps.Marker({
                        map: map,
                        position: new google.maps.LatLng(
                            parseFloat(lat),
                            parseFloat(lng)
                        ),
                        info: (infowindow),
                        icon: (blackBullet)
                    });

                    marker.info.open(map, marker);

                    google.maps.event.addListener(marker, 'click', () => {
                        clearActiveMarker();
                        clearActiveBullets();
                        wntrTheme.body.find(`.property--map#${id}`).addClass('property--is-active');
                        const infoWindow = wntrTheme.body.find(`.info-window#${id}`);
                        infoWindow.addClass('is-active');
                        infoWindow.closest('.gm-style-iw-t').addClass('is-active');
                        marker.setIcon(yellowBullet);
                    });
                    index++;
                    wntrTheme.markersArray.push(marker);
                });
            }

            function clearActiveMarker() {
                wntrTheme.body.find('.is-active').removeClass('is-active');
                wntrTheme.body.find('.gm-style-iw-t').removeClass('is-active');
                wntrTheme.body.find('.property--is-active').removeClass('property--is-active');
            }

            function clearActiveBullets() {
                for(let i = 0; i < wntrTheme.markersArray.length; i++) {
                    if(zoomLevel === 1) {
                        wntrTheme.markersArray[i].setIcon({
                            url: lyyski.get_template_directory_uri + '/src/images/bullet.svg',
                            size: new google.maps.Size(17, 17),
                            scaledSize: new google.maps.Size(17, 17)
                        });
                    } else {
                        wntrTheme.markersArray[i].setIcon({
                            url: lyyski.get_template_directory_uri + '/src/images/bullet.svg',
                            size: new google.maps.Size(0, 0),
                            scaledSize: new google.maps.Size(0, 0)
                        });
                    }
                }
            }

            wntrTheme.body.find('.property__close').on('click', (e) => {
                e.preventDefault();
                clearActiveMarker();
                clearActiveBullets();
            });

            wntrTheme.body.on('click', '.info-window', function() {
                clearActiveMarker();
                clearActiveBullets();
                const id = $(this).data('id');
                wntrTheme.body.find(`.property--map#${id}`).addClass('property--is-active');
                $(this).closest('.gm-style-iw-t').addClass('is-active');
                $(this).addClass('is-active');
                if(zoomLevel === 2) {
                    wntrTheme.markersArray[$(this).data('index')].setIcon({
                        url: lyyski.get_template_directory_uri + '/src/images/bullet-yellow.svg',
                        size: new google.maps.Size(0, 0),
                        scaledSize: new google.maps.Size(0, 0)
                    });
                }
            });

            wntrTheme.body.find('.archive-property-preview__close-map').on('click', () => {
                FWP.soft_refresh = true;
                FWP.refresh();
                toggleMap();
                showMapBtn.toggleClass('map-btn-is-active');
                clearActiveMarker();
            });
        },

        /**
         * Matchheight init
         */
        __doMatchHeight: () => {
            if(wntrTheme.body.find('.property-preview--card').length) {
                wntrTheme.body.find('.property__top-wrapper').matchHeight();
            }

            if(wntrTheme.body.find('.property__bottom-wrapper').length) {
                wntrTheme.body.find('.property__bottom-wrapper').matchHeight();
            }

            if(wntrTheme.body.find('.property__address').length) {
                wntrTheme.body.find('.property__address').matchHeight();
            }

            if(wntrTheme.body.find('.broker').length) {
                wntrTheme.body.find('.broker').matchHeight();
            }

        },

        /**
         * Slick slider
         */
        __initSlickSlider: function() {

            const layout = wntrTheme.body.find('.property-preview--slider');
            const archiveSlider = wntrTheme.body.find('.archive-property-preview__properties--slider');

            const settings = {
                dots: false,
                infinite: false,
                speed: 300,
                swipeToSlide: true,
                slidesToShow: 4,
                prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style=""><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M7 1L2 6L7 11" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></g></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></svg></button>',
                responsive: [
                    {
                        breakpoint: 1448,
                        settings: {
                            slidesToShow: 4,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 2,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1.5,
                            arrows: false,
                        }
                    },
                ]
            };

            if(layout.length) {
                layout.find('.property-preview__properties').slick(settings);
            }

            if(archiveSlider.length) {
                archiveSlider.slick(settings);
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);